import useBreakpoints from 'vue-next-breakpoints'
import { computed } from 'vue'

export const useBreakpoint = () => {
  const breakpoints = useBreakpoints({
    mobile: 767, // max-width: 600px
    tablet: [768], // min-width: 768px
    desktop: [1024],
    widescreen: [1152],
    fullhd: [1920]
  })

  const isMobile = computed(() => breakpoints.mobile.matches)
  const isTablet = computed(() => breakpoints.tablet.matches)
  const isDesktop = computed(() => breakpoints.desktop.matches)
  const isWidescreen = computed(() => breakpoints.widescreen.matches)
  const isFullHd = computed(() => breakpoints.fullhd.matches)

  return {
    isMobile,
    isTablet,
    isDesktop,
    isWidescreen,
    isFullHd
  }
}
